/**
 * CZNA-1596 (UC PC-08) — public error reports as the NK supervisor handles them. Mirrors the
 * DTOs of mod-czna-authorities' ErrorReportController.
 */
/** Every status, in workflow order — what the list's status filter offers. */
export var ERROR_REPORT_STATUSES = [
    'NEW', 'IN_PROGRESS', 'RESOLVED', 'DISMISSED',
];
